module.exports = __webpack_public_path__ + "static/feature.8df28d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/parts/home/Projects/projects/oppyfinder/feature.png
// module id = 507
// module chunks = 35783957827783